
import slide1 from '../../assets/images/slide1.png';
import slide2 from '../../assets/images/slide2.png';

const HeroSliderData = [
  {
    "id": 1,
    "image": slide2,
    "title": "Turkey's Most Trusted <span>Security Company</span>",
    "content": "Iron Wall X delivers comprehensive security solutions across Turkey. From corporate protection to residential safety, we provide 24/7 professional security services backed by cutting-edge technology and highly trained personnel.",
    "btnTextOne": "CONTACT US",
    "btnLinkOne": "/contact-us",
    "btnTextTwo": "OUR SERVICES",
    "btnLinkTwo": "/services-1"
  },
  {
    "id": 2,
    "image": slide1,
    "title": "Professional <span>Security Solutions</span> You Can Trust",
    "content": "Protecting businesses and families throughout Turkey with advanced CCTV systems, access control, armed security personnel, and expert risk assessment. Experience peace of mind with Iron Wall X's proven security expertise.",
    "btnTextOne": "GET A QUOTE",
    "btnLinkOne": "/contact-us",
    "btnTextTwo": "LEARN MORE",
    "btnLinkTwo": "/about"
  }
];

export default HeroSliderData;
